import { Component, Inject, OnInit } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { EnvironmentsService, LocationService } from '@out-web/core';
import { environment } from './environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { filter } from 'rxjs';
import { CookieConsentComponent } from '@out-web/components';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  imports: [RouterModule, RouterOutlet, CookieConsentComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Used Tesla for Sale United State Of America - USA';

  constructor(
    @Inject(DOCUMENT) public document: Document,
    private router: Router,
    private viewportScroller: ViewportScroller,
    @Inject(LocationService) private locationService: LocationService,
    @Inject(EnvironmentsService)
    private environmentService: EnvironmentsService,
    private meta: Meta,
    private titleService: Title,
    private auth: AuthService
  ) {
    this.environmentService.country = environment.country;
    this.environmentService.url = environment.apiUrl;
    this.environmentService.authentication = environment.authentication;

    this.auth.isAuthenticated$.subscribe((isAuth) => {
      console.log('User is authenticated?', isAuth);
    });

    this.initializeProgressBar();
    this.initializeRouteChangeHandler();
  }

  ngOnInit(): void {
    this.setMetaData();
    this.location();
  }

  private setMetaData() {
    this.titleService.setTitle(
      'Only Used Tesla | Sell Your Tesla | Only Used Tesla'
    );
    this.meta.addTags([
      {
        name: 'description',
        property: 'description',
        content: 'Only Used  Tesla | Sell Your Tesla | Only Used Tesla',
        vmid: 'description',
      },
      {
        name: 'og:description',
        property: 'og:description',
        content: 'Only Used Tesla | Sell Your Tesla | Only Used Tesla',
        hid: 'og:description',
      },
      {
        name: 'keywords',
        content: 'Only Used Tesla | Sell Your Tesla | Only Used Tesla',
      },
      {
        name: 'author',
        content: 'Only Used Tesla',
      },
    ]);
  }

  private location(): void {
    return this.locationService.setLocations([
      'Alabama',
      'Alaska',
      'Arizona',
      'Alberta',
      'British Columbia',
      'Manitoba',
      'New Brunswick',
      'Newfoundland and Hampshire',
      'Northwest Territories',
      'Nova Scotia',
      'Nunavut',
      'Prince Edward Island',
      'Quebec',
      'Saskatchewan',
      'Yukon Territory',
    ]);
  }

  private initializeProgressBar(): void {
    this.router.events.subscribe((event) => {
      const progressBar = this.document.getElementById('progressBar');
      if (!progressBar) return;
      if (event instanceof NavigationStart) {
        progressBar.style.width = '0%';
        progressBar.style.transition = 'none';
        setTimeout(() => {
          progressBar.style.width = '50%';
          progressBar.style.transition = 'width 0.5s';
        }, 10);
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        progressBar.style.width = '100%';
        setTimeout(() => {
          progressBar.style.display = 'none';
        }, 300);
      }
    });
  }

  private initializeRouteChangeHandler(): void {
    this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.handleRouteChange(event);
      });
  }

  private handleRouteChange(event: NavigationEnd): void {
    if (!event) return;
    this.scrollToTop();
  }

  private scrollToTop(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
